import { AuthUser } from "src/app/core/data/model/auth-user-model";
import { BlocState } from "../base-bloc";
import { ModifiedPackage } from "src/app/core/data/model/modified-package-model";
import { PromoCodesModel } from "src/app/core/data/model/promo-codes-model";
import { CssThemes } from "../../common";

export abstract class AppBlocState extends BlocState {}

// change user photo in header
export class ChangeUserPhotoState extends AppBlocState {
  constructor(public userImageUrl: string) {
    super();
  }
}

export class AuthenticatedUserDataReadyState extends AppBlocState {
  constructor(public user: AuthUser) {
    super();
  }
}

export class LoggedOutState extends AppBlocState {

}

export class ThemeReadyState extends AppBlocState {
  constructor(public theme: CssThemes) {
    super();
  }
}

export class UpdateThemeReadyState extends AppBlocState {
  constructor(public theme: CssThemes) {
    super();
  }
}

